import React from 'react';
import { StyleSheet, View } from 'react-native';

interface RadioboxProps {
  outerCircleColor?: string;
  innerCircleColor?: string;
  size?: number;
}

const Radiobox: React.FC<RadioboxProps> = ({
  outerCircleColor = '#675BDF',
  innerCircleColor = '#675BDF',
  size = 24,
}) => {
  const outerCircleStyle = {
    width: size,
    height: size,
    borderRadius: size / 2,
    borderColor: outerCircleColor,
    borderWidth: size / 6, // Adjust border width proportionally
  };

  const innerCircleStyle = {
    width: size / 2,
    height: size / 2,
    borderRadius: size / 4,
    backgroundColor: innerCircleColor,
  };

  return (
    <View style={[styles.outerCircle, outerCircleStyle]}>
      <View style={[styles.innerCircle, innerCircleStyle]} />
    </View>
  );
};

const styles = StyleSheet.create({
  outerCircle: {
    justifyContent: 'center',
    alignItems: 'center',
  },
  innerCircle: {
    alignSelf: 'center',
  },
});

export default Radiobox;
